import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoginService } from '../login/login.service';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {

  constructor(private _loginService : LoginService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isApiUrl = request.url.startsWith(environment.backend_url);
    // Never decorate the OAuth library's own protocol calls (e.g. the background
    // refresh POST to /oidc/token, which fires while logged in): the provider rejects
    // token requests that carry an unexpected Authorization header.
    const isOidcUrl = request.url.startsWith(environment.oidc.issuer);
    if (this._loginService.isLoggedIn && isApiUrl && !isOidcUrl) {
      // Hold the request until any in-flight token rotation finishes, so it always
      // picks up the current access token instead of racing a stale one that's about
      // to be invalidated server-side (see OidcAuthService.whenTokenStable$).
      return this._loginService.whenTokenStable$.pipe(
        switchMap(() => {
          let token = this._loginService.access_token;
          let refresh_token = this._loginService.refresh_token;
          let decorated = request.clone({
              setHeaders: {
                  'authorization': `Bearer ${token}`
              }
          });
          if (refresh_token) {
              decorated = decorated.clone({
                  setHeaders: {
                      'refresh-token': `${refresh_token}`
                  }
              })
          }
          return next.handle(decorated);
        })
      );
    }
    return next.handle(request);
  }
}
